import Wishes from "@/modules/wishlist/pages/wishes/Wishes.vue"
import WishesModerate from "@/modules/wishlist/pages/wishes/WishesModerate.vue"
import WishUpdate from "@/modules/wishlist/pages/update/Index"
import authMiddleware from "@/plugins/router/middlewares/auth"

export default [{
    path: "/wishlist/wishes",
    name: "WishlistWishes",
    component: Wishes,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/wishlist/wishes-moderate",
    name: "WishlistWishesModerate",
    component: WishesModerate,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/wishlist/wish/:id(\\d+)",
    name: "WishlistWishUpdate",
    component: WishUpdate,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/wishlist/wish/create",
    name: "WishlistWishCreate",
    component: WishUpdate,
    meta: {
        middleware: authMiddleware,
    },
}]
